export default __webpack_public_path__ + "static/media/cta.dac73a2d.png";